/**
 * back-to-results.js
 *
 * CTA "Retour aux résultats" sur fiche produit.
 * - Sur page résultats (collection/search) : mémorise l'origine (URL + libellé) en sessionStorage.
 * - Sur fiche produit : résout/valide/upgrade le href du CTA + retour intelligent.
 * - Sur fiche produit : insère la dernière page résultats visitée dans le fil d'Ariane.
 *
 * Chargé GLOBALEMENT en defer (DOM prêt, document.body dispo).
 */
(function () {
  'use strict';

  var STORE_KEY = 'mb:lastResults';
  var STORE_KEY_LABEL = 'mb:lastResultsLabel';
  var FMD_COLLECTION = '/collections/tous-nos-velos-reconditionnes-fmd';

  function ssGet(k) {
    try {
      return sessionStorage.getItem(k);
    } catch (e) {
      return null;
    }
  }

  function ssRemove(k) {
    try {
      sessionStorage.removeItem(k);
    } catch (e) {
      /* private mode : silencieux */
    }
  }

  function ssSet(k, v) {
    try {
      sessionStorage.setItem(k, v);
    } catch (e) {
      /* private mode / quota : silencieux */
    }
  }

  var LS_KEY = 'mint:derniere-recherche';

  /**
   * Miroir persistant (localStorage) de la dernière page de résultats.
   * Consommé par le bloc « Vélos vus récemment », qui survit à la fermeture de
   * l'onglet — d'où une clé distincte de STORE_KEY, volontairement liée à l'onglet.
   *
   * Une SEULE clé (finding N7) : le libellé n'est écrit nulle part, parce qu'il n'est lu
   * nulle part — le lien du bloc porte le texte du setting de section ou de la locale.
   * La première rédaction écrivait `mint:derniere-recherche-libelle` et T9 le lisait sans
   * jamais s'en servir : une clé avec un écrivain, zéro lecteur, et absente de la liste de
   * purge de T22 (clean-code n°9).
   */
  function lsSet(k, v) {
    try {
      localStorage.setItem(k, v);
    } catch (e) {
      /* private mode / quota : silencieux */
    }
  }

  function bodyClass() {
    return document.body ? document.body.className : '';
  }

  function isResultsPage() {
    var c = bodyClass();
    return c.indexOf('template-collection') !== -1 || c.indexOf('template-search') !== -1;
  }

  function isProductPage() {
    return bodyClass().indexOf('template-product') !== -1;
  }

  /**
   * Libellé de la page résultats courante, pour le fil d'Ariane produit.
   * Priorité au H1 du breadcrumb (titre court marchand, cf. snippets/breadcrumbs.liquid),
   * puis au premier H1 de la page, puis à un libellé générique (page recherche : pas de H1).
   */
  function currentResultsLabel() {
    var el = document.querySelector('.breadcrumb h1, .breadcrumb .breadcrumb__leaf') || document.querySelector('h1');
    var label = el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    if (label === '' && bodyClass().indexOf('template-search') !== -1) {
      label = 'Résultats de recherche';
    }
    if (label.length > 60) label = label.slice(0, 59).trim() + '…';
    return label;
  }

  /** Vrai si la query porte un parametre de parcours FMD. Liste partagee avec le
   *  nettoyage de `velos-vus-recemment.js` (validateTarget). */
  function hasFmdParam(search) {
    try {
      var params = new URLSearchParams(search);
      // `view` n'est filtre que sur la valeur `parcours-fmd` : le theme s'en sert aussi
      // pour `finder`, `location`, `quick-preview`, `ajax` — bloquer la cle entiere
      // priverait de miroir toute collection servie dans une vue alternative.
      return (
        params.has('fmd') ||
        params.has('fmd-generic') ||
        params.has('fmd-data') ||
        params.get('view') === 'parcours-fmd'
      );
    } catch (e) {
      return false;
    }
  }

  function storeOrigin() {
    var target = location.pathname + location.search;
    ssSet(STORE_KEY, target);
    ssSet(STORE_KEY_LABEL, currentResultsLabel());
    // Le miroir localStorage SURVIT a l'onglet, contrairement au sessionStorage ci-dessus
    // qui garde le comportement historique du bandeau « Retour aux resultats ». Y ecrire
    // une URL de parcours FMD la ferait ressortir des jours plus tard dans « Reprendre ma
    // selection », remettant le visiteur en tarification partenaire sans qu'il l'ait
    // demande. `velos-vus-recemment.js` retire ces parametres a la lecture, ce garde
    // evite de les ecrire tout court.
    //
    // MEMES 4 cles que le nettoyage de lecture, et test sur les cles PARSEES : un
    // `indexOf('fmd=')` matcherait aussi `?xfmd=1` ou un filtre dont le nom finit par
    // « fmd ». Aucun n'existe aujourd'hui, mais l'asymetrie entre les deux gardes est
    // exactement ce qui finit par diverger.
    if (hasFmdParam(location.search)) return;
    lsSet(LS_KEY, target);
  }

  /**
   * Valide une cible de retour : same-origin + chemin /collections|/search.
   * Rejette externe, //evil, javascript:.
   * Retourne pathname+search ou null.
   */
  function validateTarget(raw) {
    if (!raw) return null;
    try {
      var u = new URL(raw, location.origin);
      if (u.origin !== location.origin) return null;
      var p = u.pathname;
      var okCollections = p === '/collections' || p.indexOf('/collections/') === 0;
      var okSearch = p === '/search' || p.indexOf('/search/') === 0;
      if (okCollections === false && okSearch === false) return null;
      return u.pathname + u.search;
    } catch (e) {
      return null;
    }
  }

  function fmdFallback() {
    var p = new URLSearchParams(location.search);
    if (p.has('fmd')) return FMD_COLLECTION + '?fmd=' + encodeURIComponent(p.get('fmd'));
    if (p.has('fmd-generic')) return FMD_COLLECTION + '?fmd-generic=1';
    return '/collections/all';
  }

  function resolveTarget(refTarget) {
    return validateTarget(ssGet(STORE_KEY)) || refTarget || fmdFallback();
  }

  // Tracking GTM : réutilise l'événement header `menu_interaction` (cf. mobile-header-topbar.js).
  // menu_location dérivé du point de rendu (le même snippet est rendu à deux endroits) :
  // bandeau header mobile ('header') vs breadcrumb desktop ('product_breadcrumb').
  function trackClick(link) {
    var isMobileBanner = link && link.classList.contains('back-to-results--mobile');
    var eventData = {
      menu_location: isMobileBanner ? 'header' : 'product_breadcrumb',
      menu_parent: '',
      section_name: '',
      menu_label: 'Retour aux résultats',
    };
    if (typeof window.trackEvent === 'function') {
      window.trackEvent('menu_interaction', eventData);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'menu_interaction' }, eventData));
    }
  }

  /**
   * Fil d'Ariane produit : insère la dernière page résultats visitée entre le
   * premier maillon (Accueil, ou "Nos vélos éligibles FMD" en parcours FMD) et le produit.
   * Uniquement sur le breadcrumb visible : la version SEO (.breadcrumb--seo + JSON-LD)
   * doit rester la hiérarchie canonique des collections, pas le parcours utilisateur.
   */
  function injectBreadcrumbOrigin() {
    var target = validateTarget(ssGet(STORE_KEY));
    var label = ssGet(STORE_KEY_LABEL);
    if (!target || !label) return;

    var crumbs = document.querySelectorAll('.breadcrumb:not(.breadcrumb--seo)');
    Array.prototype.forEach.call(crumbs, function (nav) {
      if (nav.hasAttribute('data-origin-injected')) return;
      var first = nav.querySelector('a');
      var divider = nav.querySelector('.breadcrumb__divider');
      if (!first || !divider) return;
      // Le 1er maillon pointe déjà sur cette page (ex. parcours FMD) : pas de doublon.
      if (validateTarget(first.getAttribute('href')) === target) return;

      var link = document.createElement('a');
      link.setAttribute('href', target);
      link.textContent = label;

      var sep = divider.cloneNode(true);
      first.insertAdjacentElement('afterend', link);
      link.insertAdjacentElement('beforebegin', sep);
      nav.setAttribute('data-origin-injected', '');
    });
  }

  function wireProduct() {
    var refTarget = validateTarget(document.referrer);
    var target = resolveTarget(refTarget);
    var links = document.querySelectorAll('[data-back-to-results]');
    Array.prototype.forEach.call(links, function (link) {
      link.setAttribute('href', target);
      link.addEventListener('click', function (e) {
        trackClick(link);
        if (refTarget && refTarget === target && history.length > 1) {
          e.preventDefault();
          history.back();
        }
        /* sinon : navigation native du href (dégradation scroll acceptée) */
      });
    });
  }

  // Fiche produit ≤989px (hors FMD) : collapse de la ligne logo au scroll.
  // matchMedia testé DANS onScroll (pas au câblage) → la classe est retirée
  // au passage desktop ou si FMD ; rAF + passive pour la perf (aucun jank).
  // Seuils en hystérésis (collapse à ADD_AT, expand sous REMOVE_AT) : évite le
  // flicker du toggle quand le scroll stationne au seuil. Le saut de scrollY est
  // par ailleurs neutralisé via overflow-anchor:none (cf. mint.css T9).
  // Seuils calés sur la réserve fixe de #HeaderWrapper (anti-CLS, cf. mint.css) : replié au-delà de
  // réserve − header replié (~54px, indépendant du bandeau prix), avec 10px d'hystérésis.
  function wireProductScroll() {
    var ADD_AT = 90;
    var REMOVE_AT = 80;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var isDesktop = window.matchMedia('(min-width: 990px)').matches;
        var isFmd = document.body.hasAttribute('is-fmd');
        var collapsed = document.body.classList.contains('header-mobile-scrolled');
        var y = window.pageYOffset;
        if (isDesktop || isFmd) {
          collapsed = false;
        } else if (collapsed === true && y < REMOVE_AT) {
          collapsed = false;
        } else if (collapsed === false && y > ADD_AT) {
          collapsed = true;
        }
        document.body.classList.toggle('header-mobile-scrolled', collapsed);
        // Marqueur permanent posé au 1er collapse : arme l'animation de réouverture du bandeau
        // (back-to-results.css) uniquement APRÈS un premier collapse, jamais au chargement.
        if (collapsed === true) {
          document.body.classList.add('header-has-collapsed');
        }
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  function init() {
    if (isResultsPage()) {
      storeOrigin();
      return;
    }
    if (isProductPage()) {
      wireProduct();
      injectBreadcrumbOrigin();
      // Collapse au scroll UNIQUEMENT si la barre Retour est rendue (réglage marchand
      // show_product_mobile_banner) : sinon collapser la ligne logo laisserait un header vide.
      if (document.querySelector('.lld-header-banner--back')) {
        wireProductScroll();
      }
      return;
    }
    // Passage par une autre page (accueil, panier...) : le parcours de recherche est fini,
    // une fiche ouverte ensuite ne doit plus afficher ces resultats dans son fil d'Ariane.
    ssRemove(STORE_KEY);
    ssRemove(STORE_KEY_LABEL);
  }

  window.addEventListener('pageshow', function () {
    if (isResultsPage()) storeOrigin();
    // bfcache : resynchronise l'état collé du header produit (classe potentiellement périmée
    // après restauration). Le listener scroll (s'il existe) recalcule via onScroll.
    if (isProductPage()) window.dispatchEvent(new Event('scroll'));
  });

  // Capture l'URL au moment de QUITTER la page résultats. Les filtres sont
  // appliqués en AJAX et mettent à jour location.search via history.pushState
  // (theme.js), mais après le chargement → init()/pageshow ne les voient pas.
  // pagehide capture l'état final (filtres + sort inclus) avant la navigation,
  // pour que « Retour aux résultats » revienne sur la collection filtrée.
  window.addEventListener('pagehide', function () {
    if (isResultsPage()) storeOrigin();
  });

  init();
})();
